import $ from 'jquery';
import _ from 'underscore';

import loadLanguage from 'source/lib/loaders/language';
import Settings from 'source/lib/settings_model';
import stringToUrl from 'source/lib/utils/string_to_url';

import BaseView from 'source/lib/base_view';
import template from 'authentication/templates/parts/footer.html';

const OPEN_FOOTER_CLASS = 'select-region__open';
const CONTEXT = Symbol('context');

const FooterView = BaseView.extend({
    template,
    initialize(options = {}) {
        this.router = options.router;
        if (this.$el.length === 0) {
            return;
        }
        this.bindEvents();
        this.$scroll = $('html, body');
        $('.js-footer').removeClass('hidden');
        this.render();
    },
    bindEvents() {
        this.delegateEvents({
            'click .js-region-change-selector': 'toogleRegionsList',
            'click .js-select-region a': 'selectLanguage',
        });
    },

    selectLanguage(event = {}) {
        const $link = $(event.currentTarget);
        const linkUrl = stringToUrl($link.attr('href'));

        if (linkUrl.searchParams.has('change_realm')) {
            return true;
        }
        event.preventDefault();

        if (!$link.hasClass('js-active-lang')) {
            const language = linkUrl.searchParams.get('language');

            loadLanguage(language).then(() => {
                this.router.trigger('changelanguage', language);
                document.children[0].setAttribute('lang', language);
                this.render();
                if (window.GS && window.GS.CommonMenu) {
                    window.GS.CommonMenu.update({ language });
                }
            });
        }
        this.toogleRegionsList();
        return false;
    },
    toogleRegionsList() {
        const $selectRegion = $('.js-select-region');
        $selectRegion.toggleClass(OPEN_FOOTER_CLASS).promise().done(() => {
            let height = $(document).outerHeight();
            if ($selectRegion.hasClass(OPEN_FOOTER_CLASS)) {
                this.$scroll.animate({
                    scrollTop: `${height}px`,
                }, 300, () => {
                    height = $(document).outerHeight();
                    this.$scroll.scrollTop(height);
                });
            }
        });
        return false;
    },
    render() {
        BaseView.prototype.render.call(this, this.context());
    },
    context() {
        const currentLanguageCode = Settings.get('General.LanguageCode');
        const currentRealm = Settings.get('Realm.CurrentRealm');

        if (this[CONTEXT] && this[CONTEXT].currentLanguageCode === currentLanguageCode
            && this[CONTEXT].currentRealm === currentRealm) {
            return this[CONTEXT];
        }

        const geowidgetsChangeWidgetItems = Settings.get('Request.GeowidgetsChangeWidgetItems', []);
        const realmData = geowidgetsChangeWidgetItems.map(([
            realm, url, regionName, langs,
        ]) => {
            const isCurrentRealm = currentRealm === realm;
            const languageData = langs.map(([
                languageCode, languageName, languageUrl,
            ]) => {
                const isCurrentLang = isCurrentRealm && currentLanguageCode === languageCode;
                return {
                    languageCode,
                    languageName,
                    languageUrl,
                    isCurrentLang,
                };
            });
            return {
                realm,
                url,
                regionName,
                isCurrentRealm,
                languageData,
            };
        });
        const isLgRealm = Settings.get('Realm.CurrentRealm') === 'lg';
        const isLesta = Settings.get('Realm.Brand') === 'lesta';
        let lgRealmLinkStart;
        if (isLgRealm) {
            lgRealmLinkStart = `<a href="${Settings.get('Realm.UrlWargamingCom')}" class="copyright-airy_link">`;
        }
        const isLgOrCn360Realm = ['cn360', 'lg'].includes(Settings.get('Realm.CurrentRealm'));
        const context = {
            currentLanguageCode,
            currentRealm,
            isKrSgRealm: _.contains(['sg', 'cn'], currentRealm),
            isCn360Realm: Settings.get('Realm.CurrentRealm') === 'cn360',
            featureRealmCn: Settings.get('Realm.FeatureRealm') === 'cn',
            legalAge: currentRealm === 'ru' ? '&nbsp;12+' : '',
            isMultiRealm: realmData.length > 1,
            isLgOrCn360Realm,
            isLgRealm,
            isLesta,
            lgRealmLinkStart,
            realmData,
        };
        const currentRegion = _.find(context.realmData, (realm) => realm.isCurrentRealm);
        if (currentRegion) {
            const currentLang = _.find(currentRegion.languageData, (lang) => lang.isCurrentLang);
            context.current = {
                region: currentRegion,
                lang: currentLang,
            };
        }
        this[CONTEXT] = context;
        return context;
    },
});

export default FooterView;
